import React, { ReactNode } from "react";
import { useAuth } from "../../../context/AuthContext";
import { getToken } from "../../../App";
import { Navigate } from "react-router-dom";
// A component that manages access control based on user roles and permissions, 
// rendering children or a no-access message accordingly.

interface PermissionTypes {
  create?: boolean;
  read?: boolean;
  update?: boolean;
  delete?: boolean;
}

interface UserPermissions {
  [role: string]: {
    [permission: string]: PermissionTypes;
  };
}

interface RequiredPermission {
  permission: string;
  types: (keyof PermissionTypes)[];
}

interface AccessControlProps {
  children: ReactNode;
  requiredPermissions: RequiredPermission[];
  renderNoAccess?: ReactNode;
}

const AccessControl: React.FC<AccessControlProps> = ({
  children,
  requiredPermissions,
  renderNoAccess = null,
}) => {
  const { user } = useAuth();
  const userRoles: string[] = user?.userData?.roles || [];
  const userPermissions: UserPermissions = user?.userData?.permissions || {};

  const token = getToken();
  if (!token) {
    return <Navigate to="/login" />;
  }

  let access =  false
    // Check if the user has all required permissions
  requiredPermissions.every(({permission,types})=>{

    userRoles.some((role)=>{

      const rolePermissions = userPermissions[role]?.[permission];// Get permissions for the role
    if(rolePermissions){
      let response = types.some((type)=>{
        if(access === true){
          access = true // If access is already granted, keep it true
        }
        else {
          access = rolePermissions[type]?true:false
        }
        
      })

      
    }
    })
 
  })


  return access ? <>{children}</> : <>{renderNoAccess}</>;
};

export default AccessControl;








































  // const hasAccess = requiredPermissions.every(({ permission, types }) =>
    
  //   userRoles.some((role) => {
  //     console.log(role);
      
  //     const rolePermissions = userPermissions[role]?.[permission];

  //     let test = rolePermissions
  //       ? types.every((type) => rolePermissions[type] === true)
  //       : false;
  //     console.log(permission, types, test);
  //     return test;
      
  //   })
  // );